module.exports = __webpack_public_path__ + "img/bespoke123_21.a0df55b1.jpg";